
<div class="container-fluid pt-5 pb-5">
    <div class="d-flex flex-row bd-highlight"> 
      <div class="pt-5 col-xl-4 col-lg-6 col-md-8 col-sm-10 mx-xl-auto mx-lg-auto mx-md-auto mx-sm-auto content-main">
        <div class="card mx-auto border-0 shadow-lg round">
          <img [src]="coverPhoto" class="card-img-top img-cover" alt="...">        
          
          <!-- Google Authentication -->
          <div class="card-body">
            <div class="card-title h3">Login with Google</div>            
            <div class="m-1">Sign in to PNGL with Your Google Account. By logging in, you agree to the terms and privacy policies of PNGL.</div>
            <button (click)="loginWithGoogle()" type="button" class="btn btn-primary btn-lg btn-block rounded-pill shadow-lg my-5">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-google" viewBox="0 0 16 16">
                <path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z"/>
              </svg>
              Login with Google
            </button>
            <button (click)="routeHomePage()" class="btn btn-dark btn-lg btn-block rounded-pill shadow-lg">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-house-fill" viewBox="0 0 16 16">
                <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"/>
                <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"/>
              </svg>
              Return To Home Page
            </button>

          <!-- Phone Authentication -->
          <!-- <div class="m-3">
            <ng-container *ngIf="visible">
              <div class="alert alert-secondary" role="alert">
                For the time being, only users with PNG (+675) mobile numbers can register. 
                Later, we will allow mobile numbers from other countries to register and create personal profiles with PNGL.
              </div>
              <label class="font-weight-bold">Enter Your Mobile Number:</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <button class="btn border border-dark" type="button" id="button-addon1">
                    +675
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                    </svg>
                  </button>
                </div>
                <input type="number" [(ngModel)]="phoneNumber" placeholder="72220000" 
                  class="form-control border border-dark" required minlength="8" maxlength ="8">
                <span class="text-danger font-weight-bold">{{errorMessageId}}</span>
              </div>
              <button (click)="sendVerificationCode(spinnerContent)" [disabled]="disableButton" 
                class="btn btn-danger btn-sm btn-lg btn-block my-3">
                Send Verification Code
              </button>

            </ng-container>
            
            #Verifying Modal     
            <ng-template #spinnerContent let-c="close" let-d="dismiss">
              <div class="modal" style="display: flex; justify-content: center; align-items: center;">
                  <div class="spinner-grow text-danger"></div>
              </div>
            </ng-template>

            #Verification
            <div *ngIf="verificationId">
              <hr>
              <label>Enter the 6-digit Verification Code send to mobile number <b>+(675){{phoneNumber}}</b>. Click Verify Code to login and Enjoy PNGL!!</label>
              <input type="number" maxlength="6" class="form-control border border-dark" [(ngModel)]="verificationCode">
              <span class="text-danger font-weight-bold">{{errorMessageCode}}</span>
              <button (click)="verifyCode(spinnerContent)" class="btn btn-danger btn-sm btn-lg btn-block my-3">Verify Code</button>
            </div>
            <div id="recaptcha-container"></div>
            <hr>
            <button (click)="routeHomePage()" class="btn btn-dark btn-sm btn-lg btn-block mt-4">Cancel & Return Home</button>
                     
          </div> -->
        </div>
      </div>
    </div>
  
  </div>
    